import { Tournament, Participant, Game } from '../types'
import { getRandomInt } from '../../draft/utils/drafter'

import { DraftOptions } from 'draft/types'

import { GetTeamHash, AddTeamToTable } from './Evaluator'

let TotalGroupStageMatches = 0;
let MatchesPrPlayer = 0;

export const GenerateTournament = (
  players: Participant[],
  groupMatchesCount: number,
  matchesPrHeat: number,
  draftOptions: DraftOptions): Tournament => {
  let createdTour: Tournament = NewTournament(players, groupMatchesCount, matchesPrHeat, draftOptions);

  while (!ValidateTour(createdTour)) {
    createdTour = NewTournament(players, groupMatchesCount, matchesPrHeat, draftOptions);
  }

  renameGroupstageMatches(createdTour.GroupStageGames)
  return createdTour;
}

const NewTournament = (
  players: Participant[],
  groupStageMatchCount: number,
  matchesPrHeat: number,
  draftOptions: DraftOptions
): Tournament => {
  const games: Game[] = []

  let teamsTable = {}
  TotalGroupStageMatches = GetTotalGroupStageMatches(players.length, groupStageMatchCount);
  MatchesPrPlayer = groupStageMatchCount;

  let tourId = 'Tournament#' + Math.random().toString(36).substring(7);

  const heatCount = TotalGroupStageMatches / matchesPrHeat;
  const restMatches = TotalGroupStageMatches - (heatCount * matchesPrHeat)

  // Heats
  for (var heatIndex = 0; heatIndex < heatCount; heatIndex++) {
    let eligiblePlayers = GetEligiblePlayers(games, players);

    if (eligiblePlayers.length < 4) {
      console.error("Oupsi - less than 4 eligible players, should not happend?")
    }

    for (var j = 0; j < matchesPrHeat; j++) {
      games.push(GenerateGame(eligiblePlayers, teamsTable, tourId, heatIndex));
    }
  }

  // Rest Matches
  for (var restIndex = 0; restIndex < restMatches; restIndex++) {
    let eligiblePlayers = GetEligiblePlayers(games, players);
    games.push(GenerateGame(eligiblePlayers, teamsTable, tourId, -1));
  }

  return {
    Id: tourId,
    Name: "",
    DraftOptions: draftOptions,
    CreatedAt: new Date(),
    GroupStageGames: games,
    MatchesPrHeat: matchesPrHeat,
    Players: players
  };
}



const GenerateGame = (
  eligiblePlayers: Participant[],
  teamsTable: any,
  tourId: string,
  currentHeat: number): Game => {
  const newGame: Game = {
    Id: Math.random().toString(36).substring(7),
    TournamentId: tourId,
    Players: [],
    TeamBlue: [],
    TeamRed: [],
    Winners: [],
    Heat: currentHeat + 1
  }

  const teamBlue = GenerateTeam(eligiblePlayers, teamsTable);
  teamBlue.forEach((p: Participant) => {
    newGame.TeamBlue.push(p)
    const index = eligiblePlayers.indexOf(p);
    eligiblePlayers.splice(index, 1);
    newGame.Players.push(p);
  });

  const teamRed = GenerateTeam(eligiblePlayers, teamsTable);
  teamRed.forEach((p) => {
    newGame.TeamRed.push(p);
    const index = eligiblePlayers.indexOf(p);
    eligiblePlayers.splice(index, 1);
    newGame.Players.push(p);
  })

  AddTeamToTable(teamsTable, teamBlue);
  AddTeamToTable(teamsTable, teamRed);

  return newGame;
}

const GenerateTeam = (eligiblePlayers: Participant[], teamsTable: any): Participant[] => {
  let eligiblePlayersCopy = eligiblePlayers.slice();

  let rng = getRandomInt(eligiblePlayersCopy.length);
  const pickedPlayer = eligiblePlayersCopy[rng];

  eligiblePlayersCopy.splice(rng, 1); //removing picked player from list   

  let optimalTeam: Participant[] = [];
  let optimalTeamFrequency = Number.MAX_SAFE_INTEGER;
  while (eligiblePlayersCopy.length > 0) {
    rng = getRandomInt(eligiblePlayersCopy.length);
    const potentialTeammate = eligiblePlayersCopy[rng];

    const teamHash = GetTeamHash([pickedPlayer, potentialTeammate]);
    let frequency = teamsTable[teamHash] ? teamsTable[teamHash] : 0; //Henter ut antall ganger de to har vært på lag, ellers 0
    if (frequency < optimalTeamFrequency) {
      optimalTeam = [pickedPlayer, potentialTeammate];
      optimalTeamFrequency = frequency;
      if (frequency === 0) break;
    }
    eligiblePlayersCopy.splice(rng, 1);
  }
  return optimalTeam;
}

const GetEligiblePlayers = (games: Game[], players: Participant[]): Participant[] => {
  const eligiblePlayers: Participant[] = [];
  players.forEach((p) => {
    if (GetGamesPlayed(p, games) < MatchesPrPlayer) {
      eligiblePlayers.push(p);
    }
  })
  return eligiblePlayers;
}

const GetGamesPlayed = (player: Participant, games: Game[]): number => {
  let played = 0;
  games.forEach((g) => {
    if (g.Players.includes(player)) played++;
  })
  return played;
}


export const GetTotalGroupStageMatches = (playerCount: number, groupStageMatchCount: number) => {
  return (playerCount * groupStageMatchCount / 4);
}

const renameGroupstageMatches = (games: Game[]) => {
  games.forEach((game, index) => {
    game.Name = `Game ${(index + 1)}`
  })
}

const ValidateTour = (tour: Tournament): boolean => {
  if (!tour.Players || !tour.GroupStageGames) return false;
  let validated = true;
  tour.Players.forEach((p) => {
    if (GetGamesPlayed(p, tour.GroupStageGames!) !== MatchesPrPlayer) {
      validated = false;
    }
  })

  if (isSTierPlayersTeamedMoreThanOnce(tour)) {
    validated = false
  }

  return validated;
}

export const StandardMatchesPrHeat = (players: Participant[]) => {
  return Math.floor(players.length / 4);
}

// Remove after Julebord 2025
const isSTierPlayersTeamedMoreThanOnce = (
  tour: Tournament,
): boolean => {
  let teamsTable: any = {};
  tour.GroupStageGames.forEach((g) => {
    AddTeamToTable(teamsTable, g.TeamBlue);
    AddTeamToTable(teamsTable, g.TeamRed);
  });

  const martin = tour.Players.find((p) => p.Name.toLowerCase() === "martin");
  const fredrik = tour.Players.find((p) => p.Name.toLowerCase() === "fredrik");
  const odin = tour.Players.find((p) => p.Name.toLowerCase() === "odin");

  if (odin && martin) {
    const martinOdin = GetTeamHash([martin, odin]);
    if (teamsTable[martinOdin] > 1) {
      return true;
    }
  }

  if (odin && fredrik) {
    const odinFredrik = GetTeamHash([fredrik, odin]);
    if (teamsTable[odinFredrik] > 1) {
      return true;
    }
  }

  if (martin && fredrik) {
    const martinFredrik = GetTeamHash([fredrik, martin]);
    if (teamsTable[martinFredrik] > 1) {
      return true;
    }
  }
  return false;
};
